import { useState, useEffect, useCallback } from 'react'

import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { SvgIcon } from '@progress/kendo-react-common'

import ExcelFileImport, {
    EXCEL_DATA_TYPES,
} from '../../GlobalComponents/ExcelFileImport/ExcelFileImport'

import {
    AWCButton,
    DropdownList,
    FastQuoteInput,
    ToggledInput,
} from '../../GlobalComponents/Inputs/Inputs'
// import { ImportModal } from '../../GlobalComponents/ImportModal'
import { EditPencil } from '../../GlobalComponents/_icons/Icons'

import { getSpecificPartInfo, SpannifyText } from './LineItems'
import { fqAlert } from '../../GlobalComponents/NotificationManager/NotificationManager'

import { Scrollbars } from 'react-custom-scrollbars-2'

import { MenuItem, TextField } from '@material-ui/core'
import { SelectChangeEvent } from '@mui/material/Select'

import styles from './ImportBOMModal.module.scss'
import './ImportBOMModal.scss'

import _ from 'lodash'

import * as XLSX from 'xlsx'

import {
    GetOrderReturnPayload,
    QuoteUserInfo,
    WarehouseReturnPayload,
    fetchImportBOM,
    ImportBOMFetchParams,
    ImportBOMReturnLI,
    ImportBOMLI,
    fetchParts,
    PartSearchInfo,
} from '../../features/order/orderAPI'

import {
    addLineItemFromBOM,
    getOrderMiscInfo,
    PayloadOrderDetailViewRow,
    PayloadOrderHeaderViewRow,
} from '../../features/order/orderSlice'
import { LOADING_STATES } from '../../features/meta/metaSlice'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { DatePicker } from '../../GlobalComponents/DateInput/DateInput'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { fetchVendorData } from '../../features/inventory/inventoryAPI'

interface ImportBOMTitleBarProps {
    close(): void
}

const ImportBOMTitleBar = ({ close }: ImportBOMTitleBarProps) => {
    return (
        <div className={styles.importBOMTitleBar}>
            <div style={{ display: 'inline-block', width: 350 }}>Import BOM</div>
            <div
                style={{ display: 'inline-block', float: 'right' }}
                className='a-i-close'
                onClick={close}
            />
        </div>
    )
}

interface ImportBOMModalProps {
    close(): void
    onSubmit(): void
    orderHeader: PayloadOrderHeaderViewRow[]
}

interface MappingListMenuItem {
    text: string
    value: string
}

export const ImportBOMModal = (props: ImportBOMModalProps) => {
    const { close } = props

    const orderHeader = useAppSelector((state) => state.order.orderHeader)

    const [bom, setBOM] = useState<any[]>()

    const [bomImportStatus, setBOMImportStatus] = useState<LOADING_STATES>(LOADING_STATES.INIT)

    const [bomLineItems, setBOMLineItems] = useState<Array<ImportBOMReturnLI>>([])
    const [lineItemsInput, setLineItemsInput] = useState<Array<ImportBOMLI>>([])

    const getRowProblem = (dataItem: ImportBOMLI, fieldName: string) => {
        let message = ''
        bomLineItems.forEach((line) => {
            if (line.Row === dataItem.Row.Value) {
                if (line.Problem) {
                    if (line.Problem.FieldName === fieldName) {
                        message = line.Problem.Message
                    }
                }
            }
        })

        return message
    }

    useEffect(() => {
        if (!lineItemsInput || lineItemsInput.length === 0) return

        fetchVendorData()

        async function fetchBOMLineItems(input: ImportBOMFetchParams) {
            const bomLineItemsPayload = await fetchImportBOM(input)

            setBOMLineItems(bomLineItemsPayload)
        }
        let importLIs: ImportBOMFetchParams = {
            OrderNumber: orderHeader[0].OrderNumber,
            CustomerAccountCode: orderHeader[0].CustomerAccountCode,
            SellingLocation: orderHeader[0].Location,
            BOMLineItems: lineItemsInput,
        }
        fetchBOMLineItems(importLIs)
    }, [lineItemsInput])

    useEffect(() => {
        setBOMImportStatus(
            bomLineItems && bomLineItems.length > 0 ? LOADING_STATES.DONE : LOADING_STATES.INIT
        )
    }, [bomLineItems])

    const RowCell = (dataItem: any) => (
        <td style={{ textAlign: 'right', padding: '10px 24px' }}>{dataItem.Row.Value}</td>
    )

    interface ImportBOMPartNumberProps {
        partNumber: string
        accountCode: string
        rowNumber: number
    }

    const ImportBOMPartNumber = (props: ImportBOMPartNumberProps) => {
        const { partNumber, accountCode, rowNumber } = props

        const [loading, setLoading] = useState(false)

        const [value, setValue] = useState<string | null>(partNumber || '')
        const [inputValue, setInputValue] = useState('')

        const [parts, setParts] = useState<Array<PartSearchInfo>>([])

        const getParts = useCallback(
            _.debounce(
                async (search: string, controller: AbortController) => {
                    setLoading(true)
                    setParts([])
                    let parts = await fetchParts(
                        { searchValue: search, accountCode: accountCode },
                        controller
                    )
                    if (parts) {
                        setParts(parts.d)
                    }
                    setLoading(false)
                },
                500,
                { trailing: true }
            ),
            []
        )

        useEffect(() => {
            if (inputValue) {
                const controller = new AbortController()

                getParts(inputValue, controller)

                return () => {
                    controller.abort()
                }
            }
        }, [inputValue])

        return (
            <Autocomplete
                freeSolo
                options={parts.filter((data: PartSearchInfo) => data.Source !== 'ProductCount')}
                value={value}
                defaultValue={partNumber}
                loading={loading}
                onChange={async (event: any, value: any) => {
                    // when an option is selected
                    if (typeof value !== 'string') {
                        if (value) {
                            setInputValue(value.Name.toUpperCase())

                            let info = await getSpecificPartInfo(value, accountCode)

                            const temp = lineItemsInput.map((line) => {
                                if (line.Row.Value === rowNumber) {
                                    line.PartNumber.Value = info.PartInfo.PartNumber
                                }
                                return line
                            })

                            setLineItemsInput(temp)
                        }
                    } else {
                        if (value) {
                            setInputValue(value.toUpperCase())
                        }
                    }
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue)
                }}
                id='controllable-states-demo'
                filterOptions={(options, state) => {
                    return options
                }}
                renderOption={(option, state) => {
                    let divs = [...option.Markup.matchAll(/<div>(.*?)<\/div>/g)]

                    return (
                        <div>
                            <div style={{ fontWeight: 500, fontSize: 12 }}>{divs[0][1]}</div>
                            {divs[1] && <div style={{ fontSize: 10 }}>{divs[1][1]}</div>}
                        </div>
                    )
                }}
                renderInput={(params) => <FastQuoteInput {...params} />}
            />
        )
    }

    const PartNumberCell = (dataItem: ImportBOMLI) => {
        const errorMessage = getRowProblem(dataItem, 'PartNumber')

        const bomLine = bomLineItems.find((line) => dataItem.Row.Value === line.Row)

        return (
            <td style={{ padding: '10px 24px' }}>
                <div style={{ paddingRight: '10px' }}>
                    {errorMessage || !dataItem.PartNumber.Value ? (
                        <ImportBOMPartNumber
                            partNumber={
                                dataItem.PartNumber.Value
                                    ? dataItem.PartNumber.Value.toString()
                                    : ''
                            }
                            accountCode={orderHeader[0].CustomerAccountCode}
                            rowNumber={dataItem.Row.Value}
                        />
                    ) : bomLine && bomLine.LineItem ? (
                        <div>{bomLine.LineItem.PartNumber}</div>
                    ) : (
                        <div>{dataItem.PartNumber.Value}</div>
                    )}
                </div>
                {errorMessage !== '' && <div style={{ color: 'red' }}>{errorMessage}</div>}
            </td>
        )
    }

    const QuantityCell = (dataItem: ImportBOMLI) => {
        const errorMessage = getRowProblem(dataItem, 'OrderQuantity')

        function isNumeric(value: string) {
            return /^-?\d+$/.test(value)
        }

        return (
            <td style={{ padding: '10px 24px' }}>
                <div style={{ paddingRight: '10px', textAlign: 'right' }}>
                    {errorMessage || !dataItem.Quantity.Value ? (
                        <ToggledInput
                            value={
                                dataItem.Quantity.Value ? dataItem.Quantity.Value.toString() : ''
                            }
                            onChange={async (newVal: any) => {
                                if (isNumeric(newVal)) {
                                    const temp = lineItemsInput.map((line) => {
                                        if (line.Row.Value === dataItem.Row.Value)
                                            line.Quantity = { Value: newVal }

                                        return line
                                    })

                                    setLineItemsInput(temp)
                                }
                            }}
                            textAlign='right'
                        />
                    ) : (
                        dataItem.Quantity.Value
                    )}
                </div>
                {errorMessage !== '' && <div style={{ color: 'red' }}>{errorMessage}</div>}
            </td>
        )
    }

    const LineItemNotesCell = (dataItem: ImportBOMLI) => {
        const errorMessage = getRowProblem(dataItem, 'LineItemNotes')
        const [tempText, setTempText] = useState<string>(dataItem.LineItemNotes?.Value)
        const [isEditing, setIsEditing] = useState<boolean>(false)

        return (
            <td
                style={{
                    fontSize: 12,
                    fontWeight: 300,
                    marginTop: 10,
                    padding: '10px 24px',
                }}
            >
                {isEditing ? (
                    <div>
                        <div>
                            <TextField
                                multiline={true}
                                minRows={3}
                                variant={'outlined'}
                                style={{ width: '100%' }}
                                inputProps={{
                                    style: {
                                        padding: 0,
                                    },
                                }}
                                value={tempText}
                                onChange={(e) => {
                                    setTempText(e.target.value)
                                }}
                                onKeyDown={(event: any) => {
                                    if (event.key === 'Enter' || event.key === 'Tab') {
                                        setIsEditing(false)
                                        const temp = lineItemsInput.map((line) => {
                                            if (line.Row.Value === dataItem.Row.Value)
                                                line = {
                                                    ...line,
                                                    LineItemNotes: { Value: tempText },
                                                }

                                            return line
                                        })

                                        setLineItemsInput(temp)
                                    }
                                }}
                                onBlur={(event: any) => {
                                    event.target.blur()
                                    setIsEditing(false)
                                    const temp = lineItemsInput.map((line) => {
                                        if (line.Row.Value === dataItem.Row.Value)
                                            line = {
                                                ...line,
                                                LineItemNotes: { Value: tempText },
                                            }

                                        return line
                                    })

                                    setLineItemsInput(temp)
                                }}
                            />
                        </div>
                        <div
                            style={{
                                width: '100%',
                                fontSize: 12,
                                fontWeight: 300,
                            }}
                        >
                            <AWCButton
                                type={'link'}
                                style={{ fontWeight: 400, fontSize: 12 }}
                                onClick={() => {
                                    setIsEditing(false)
                                    const temp = lineItemsInput.map((line) => {
                                        if (line.Row.Value === dataItem.Row.Value)
                                            line = {
                                                ...line,
                                                LineItemNotes: { Value: tempText },
                                            }

                                        return line
                                    })

                                    setLineItemsInput(temp)
                                }}
                            >
                                Done
                            </AWCButton>
                        </div>
                    </div>
                ) : (
                    <SpannifyText text={dataItem.LineItemNotes?.Value} font={''} textRows={3}>
                        <SvgIcon
                            icon={EditPencil}
                            height={12}
                            onClick={() => {
                                setIsEditing(true)
                            }}
                            style={{
                                cursor: 'pointer',
                                paddingLeft: 10,
                                paddingBottom: 8,
                                paddingTop: 8,
                            }}
                        />
                    </SpannifyText>
                )}
                {errorMessage !== '' && <div style={{ color: 'red' }}>{errorMessage}</div>}
            </td>
        )
    }

    const DateCell = (dataItem: ImportBOMLI) => {
        const errorMessage = getRowProblem(dataItem, 'ExpectedOnDockDate')

        return (
            <td style={{ padding: '10px 24px' }}>
                <div style={{ paddingRight: '10px', paddingBottom: 10 }}>
                    {errorMessage ||
                    !dataItem.NeedDate?.Value ||
                    isNaN(dataItem.NeedDate?.Value.getTime()) ? (
                        <DatePicker
                            minDate={new Date()}
                            value={dataItem.NeedDate?.Value}
                            onChange={(newDate: any) => {
                                const temp = lineItemsInput.map((line) => {
                                    if (line.Row.Value === dataItem.Row.Value)
                                        line = {
                                            ...line,
                                            NeedDate: { Value: newDate },
                                        }

                                    return line
                                })

                                setLineItemsInput(temp)
                            }}
                            positionRight
                            hideErrorMessage
                        />
                    ) : (
                        <>
                            {dataItem.NeedDate?.Value.toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                            })}
                        </>
                    )}
                </div>
                {errorMessage !== '' && (
                    <div style={{ color: 'red', paddingTop: 20 }}>{errorMessage}</div>
                )}
            </td>
        )
    }

    const DeleteLineCell = (dataItem: ImportBOMLI) => {
        return (
            <td style={{ padding: '10px 6px' }}>
                <div
                    onClick={() => {
                        const tempItems = lineItemsInput.filter(
                            (line) => line.Row.Value !== dataItem.Row.Value
                        )
                        if (tempItems.length === 0) {
                            fqAlert({
                                type: 'error',
                                title: 'At least one line item required to add to quote',
                            })
                        } else {
                            setLineItemsInput(tempItems)
                        }
                    }}
                    style={{ cursor: 'pointer' }}
                >
                    <span className='k-icon k-i-trash'></span>
                </div>
            </td>
        )
    }

    const ImportBOMLineItems = () => {
        return (
            <div style={{ margin: '0px 5px 0px 15px' }}>
                {bomImportStatus === LOADING_STATES.DONE && (
                    <Grid
                        data={lineItemsInput.sort((a, b) => a.Row.Value - b.Row.Value)}
                        style={{ borderRadius: '7px' }}
                        filterable={false}
                        sortable={false}
                        scrollable={'none'}
                        className='dateSection'
                    >
                        <GridColumn
                            cell={(props: any) => RowCell(props.dataItem)}
                            headerCell={() => (
                                <div style={{ textAlign: 'right', padding: '10px 24px' }}>Row</div>
                            )}
                            width={100}
                        />
                        <GridColumn
                            cell={(props: any) => PartNumberCell(props.dataItem)}
                            headerCell={() => <div style={{ padding: '10px 24px' }}>Part #</div>}
                            width={300}
                        />
                        <GridColumn
                            cell={(props: any) => QuantityCell(props.dataItem)}
                            headerCell={() => (
                                <div style={{ textAlign: 'right', padding: '10px 24px' }}>
                                    Quantity
                                </div>
                            )}
                            width={200}
                        />
                        <GridColumn
                            cell={(props: any) => LineItemNotesCell(props.dataItem)}
                            headerCell={() => (
                                <div style={{ padding: '10px 24px' }}>Line Item Notes</div>
                            )}
                        />
                        <GridColumn
                            cell={(props: any) => DateCell(props.dataItem)}
                            headerCell={() => <div style={{ padding: '10px 24px' }}>Need Date</div>}
                            width={200}
                        />
                        <GridColumn cell={(props: any) => DeleteLineCell(props.dataItem)} />
                    </Grid>
                )}
            </div>
        )
    }

    const dispatch = useAppDispatch()

    const onAddToQuoteClick = async () => {
        if (bomLineItems.find((line) => line.Problem)) {
            fqAlert({
                type: 'error',
                title: 'Please make the corrections before adding to quote',
            })
        } else {
            bomLineItems.forEach((line) => {
                dispatch(addLineItemFromBOM(line))
            })
            close()
        }
    }

    return (
        <div className={styles.dropZone} data-testid='importBOMDiv'>
            <div className={`${styles.importBOMModal} importBOMModal`}>
                <ImportBOMTitleBar close={close} />
                <div className={'a-divider'} />
                <div>
                    <ExcelFileImport
                        returnHeaderRowInResults={true}
                        onFileDropped={(importJsonData: any[]) => {
                            setBOM(importJsonData)
                        }}
                        onFileImported={(importedData: any[]) => {
                            setLineItemsInput(importedData)
                        }}
                        columnList={[
                            {
                                fieldName: 'PartNumber',
                                fieldLabel: 'Part #',
                                dataType: EXCEL_DATA_TYPES.String,
                                maxDataLength: 50,
                                required: true,
                            },
                            {
                                fieldName: 'LineItemNotes',
                                fieldLabel: 'Line Item Notes',
                                dataType: EXCEL_DATA_TYPES.String,
                            },
                            {
                                fieldName: 'Quantity',
                                fieldLabel: 'Quantity',
                                dataType: EXCEL_DATA_TYPES.Decimal,
                                required: true,
                            },
                            {
                                fieldName: 'NeedDate',
                                fieldLabel: 'Need Date',
                                dataType: EXCEL_DATA_TYPES.Date,
                            },
                        ]}
                    />
                    {bom && (
                        <>
                            <Scrollbars
                                className={`${
                                    bomImportStatus === LOADING_STATES.DONE
                                        ? ''
                                        : `${styles.scrollBar} `
                                }scroll-bar`}
                                renderTrackHorizontal={() => <div />}
                                autoHeight
                                autoHeightMin={500}
                                autoHeightMax={500}
                            >
                                <div className={styles.importBOMListContainer}>
                                    {(() => {
                                        switch (bomImportStatus) {
                                            case LOADING_STATES.INIT:
                                                return <>Import Line Items to Preview</>
                                            case LOADING_STATES.LOADING:
                                                return (
                                                    <div
                                                        className={'k-i-loading'}
                                                        style={{ fontSize: 60 }}
                                                    />
                                                )
                                            case LOADING_STATES.DONE:
                                                return <ImportBOMLineItems />
                                            default:
                                                return null
                                        }
                                    })()}
                                </div>
                            </Scrollbars>
                            <div className={styles.importBOMButtonContainer}>
                                {bomImportStatus === LOADING_STATES.DONE && (
                                    <>
                                        <AWCButton type={'secondary'} onClick={close}>
                                            Cancel
                                        </AWCButton>
                                        <AWCButton type={'primary'} onClick={onAddToQuoteClick}>
                                            Add To Quote
                                        </AWCButton>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
